var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiTypography from '@mui/material/Typography';
import { fontFamilyDefault, fontSizeBodyDefault, fontSizeBodySmall, fontSizeBodyTiny, fontSizeDisplay1, fontSizeDisplay2, fontSizeDisplay3, fontSizeH1, fontSizeH2, fontSizeH3, fontSizeH4, lineHeightBodyDefault, lineHeightBodySmall, lineHeightBodyTiny, lineHeightDisplay1, lineHeightDisplay2, lineHeightDisplay3, lineHeightH1, lineHeightH2, lineHeightH3, lineHeightH4, weightRegular, weightSemibold, } from '../../utils/tokens';
const variantMapping = Object.freeze({
    'display-1': {
        variant: 'h1',
        sx: {
            fontSize: fontSizeDisplay1,
            lineHeight: lineHeightDisplay1,
            fontFamily: fontFamilyDefault,
            fontWeight: weightRegular,
        },
    },
    'display-2': {
        variant: 'h2',
        sx: {
            fontSize: fontSizeDisplay2,
            lineHeight: lineHeightDisplay2,
            fontFamily: fontFamilyDefault,
            fontWeight: weightRegular,
        },
    },
    'display-3': {
        variant: 'h3',
        sx: {
            fontSize: fontSizeDisplay3,
            lineHeight: lineHeightDisplay3,
            fontFamily: fontFamilyDefault,
            fontWeight: weightRegular,
        },
    },
    'h1-semibold': {
        variant: 'h1',
        sx: {
            fontSize: fontSizeH1,
            lineHeight: lineHeightH1,
            fontFamily: fontFamilyDefault,
            fontWeight: weightSemibold,
        },
    },
    'h1-regular': {
        variant: 'h1',
        sx: {
            fontSize: fontSizeH1,
            lineHeight: lineHeightH1,
            fontFamily: fontFamilyDefault,
            fontWeight: weightRegular,
        },
    },
    'h2-semibold': {
        variant: 'h2',
        sx: {
            fontSize: fontSizeH2,
            lineHeight: lineHeightH2,
            fontFamily: fontFamilyDefault,
            fontWeight: weightSemibold,
        },
    },
    'h2-regular': {
        variant: 'h2',
        sx: {
            fontSize: fontSizeH2,
            lineHeight: lineHeightH2,
            fontFamily: fontFamilyDefault,
            fontWeight: weightRegular,
        },
    },
    'h3-semibold': {
        variant: 'h3',
        sx: {
            fontSize: fontSizeH3,
            lineHeight: lineHeightH3,
            fontFamily: fontFamilyDefault,
            fontWeight: weightSemibold,
        },
    },
    'h3-regular': {
        variant: 'h3',
        sx: {
            fontSize: fontSizeH3,
            lineHeight: lineHeightH3,
            fontFamily: fontFamilyDefault,
            fontWeight: weightRegular,
        },
    },
    'h4-semibold': {
        variant: 'h4',
        sx: {
            fontSize: fontSizeH4,
            lineHeight: lineHeightH4,
            fontFamily: fontFamilyDefault,
            fontWeight: weightSemibold,
        },
    },
    'h4-regular': {
        variant: 'h4',
        sx: {
            fontSize: fontSizeH4,
            lineHeight: lineHeightH4,
            fontFamily: fontFamilyDefault,
            fontWeight: weightRegular,
        },
    },
    'body-default-semibold': {
        variant: 'body1',
        sx: {
            fontSize: fontSizeBodyDefault,
            lineHeight: lineHeightBodyDefault,
            fontFamily: fontFamilyDefault,
            fontWeight: weightSemibold,
        },
    },
    'body-default-regular': {
        variant: 'body1',
        sx: {
            fontSize: fontSizeBodyDefault,
            lineHeight: lineHeightBodyDefault,
            fontFamily: fontFamilyDefault,
            fontWeight: weightRegular,
        },
    },
    'body-small-semibold': {
        variant: 'body2',
        sx: {
            fontSize: fontSizeBodySmall,
            lineHeight: lineHeightBodySmall,
            fontFamily: fontFamilyDefault,
            fontWeight: weightSemibold,
        },
    },
    'body-small-regular': {
        variant: 'body2',
        sx: {
            fontSize: fontSizeBodySmall,
            lineHeight: lineHeightBodySmall,
            fontFamily: fontFamilyDefault,
            fontWeight: weightRegular,
        },
    },
    'body-tiny': {
        variant: 'caption',
        sx: {
            fontSize: fontSizeBodyTiny,
            lineHeight: lineHeightBodyTiny,
            fontFamily: fontFamilyDefault,
            fontWeight: weightRegular,
        },
    },
});
export const Typography = React.forwardRef((_a, ref) => {
    var _b, _c;
    var { variant = 'body-default-regular', children, sx = {} } = _a, restProps = __rest(_a, ["variant", "children", "sx"]);
    // Merged sx props
    const mergedSx = Object.assign(Object.assign({}, ((_c = (_b = variantMapping[variant]) === null || _b === void 0 ? void 0 : _b.sx) !== null && _c !== void 0 ? _c : {})), (sx !== null && sx !== void 0 ? sx : {}));
    return (React.createElement(MuiTypography, Object.assign({ ref: ref }, variantMapping[variant], { sx: mergedSx }, restProps), children));
});
Typography.displayName = 'Typography';
